import { useQuery } from '@apollo/client';
import { item as roomItem } from '@/graph/rooms';
import type { Room } from '../types/RoomTabletTypes';

/**
 * Custom hook for fetching room data.
 * Replaces the legacy graphql(roomItem) HOC.
 *
 * @param roomId - The ID of the room to fetch
 * @returns Object containing room data, loading state, and error
 */
export function useRoomData(roomId: number | undefined) {
  const { data, loading, error } = useQuery<{ room: Room }>(roomItem, {
    variables: { id: roomId },
    skip: !roomId,
  });

  return {
    room: data?.room,
    loading,
    error,
  };
}
